// extracted by mini-css-extract-plugin
export var bodySections = "_b6-8";
export var gray = "_b6-7";
export var green = "_b6-4";
export var iconContainer = "_b6-9";
export var iconWidgetContainer = "_b6-1";
export var phoneIcon = "_b6-2";
export var red = "_b6-5";
export var statusDot = "_b6-3";
export var widgetContainer = "_b6-0";
export var yellow = "_b6-6";